module.exports = __webpack_public_path__ + "img/1.1f3618d6.png";